import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseFirestoreService } from './base-firestore.service';
import { SMBrandOwner } from 'src/app/models/SMBrandOwner';

@Injectable({
  providedIn: 'root'
})
export class BrandOwnerService {

  COLLECTION_NAME = 'BrandOwners';
  private owner: SMBrandOwner;
  private ownerData = new BehaviorSubject(null);
  private oOwner: Observable<SMBrandOwner> = this.ownerData.asObservable();
  private ownerIDData = new BehaviorSubject(null);
  private oOwnerID: Observable<any> = this.ownerIDData.asObservable();

  constructor(private base: BaseFirestoreService) {
  }

  getOwnerID(): Observable<any> {
    return this.oOwnerID;
  }

  updateOwnerID(id: any) {
    this.ownerIDData.next(id);
  }

  getOwnerAsObservable(): Observable<SMBrandOwner> {
    return this.oOwner;
  }

  async getOwner(): Promise<SMBrandOwner> {
    if (!this.owner) {
      this.owner = await this.getOwnerFromFirebase();
      this.ownerData.next(this.owner);
    }
    return this.owner;
  }

  setOwner(owner: any) {
    this.owner = owner;
  }

  private async getOwnerFromFirebase(): Promise<SMBrandOwner> {
    const docRef = this.base.getDocRef(this.ownerIDData.value, this.COLLECTION_NAME);
    const doc = await this.base.getDoc(docRef);
    if (doc.exists) {
      const data: SMBrandOwner = Object.assign(doc.data());
      return data;
    }
    return null;
  }

  async getOwnerFromFirebaseWithId(id: string): Promise<SMBrandOwner> {
    const docRef = this.base.getDocRef(id, this.COLLECTION_NAME);
    const doc = await this.base.getDoc(docRef);
    if (doc.exists) {
      const data: SMBrandOwner = Object.assign(doc.data());
      return data;
    }
    return null;
  }

  async getBrandOwnerWithBrandID(brandID: string): Promise<SMBrandOwner> {
    return new Promise(resolve => {
      this.base.getFirestore().collection(this.COLLECTION_NAME, ref => {
        return ref.where('brandID', '==', brandID);
      }).valueChanges({ idField: 'id' }).subscribe((data: any) => {
        if(data) {
          resolve(data[0]);
        }
      });
    });
  }
  
  async updateOwner(owner: SMBrandOwner): Promise<boolean> {
    const result = await this.base.updateRecord(owner.id, owner, this.COLLECTION_NAME);
    return result;
  }

  async createOwner(owner: SMBrandOwner) {
    const docRef = this.base.getDocRef(owner.id, this.COLLECTION_NAME);
    await docRef.set(owner);
  }

  async getBrandOwners(refData: string, refStr: string): Promise< Observable < any[]> > {
    return this.base.getFirestore().collection(this.COLLECTION_NAME, ref => {
      return ref.where( refStr, '==', refData);
    }).valueChanges({ idField: 'id' });
  }
}
